import Card from 'tio-ui/components/card';
import type { TOC } from '@ember/component/template-only';
import type { ComponentLike } from '@glint/template';

interface QuestionsLoanTypesCardSignature {
  Args: {
    /** Decorative Phosphor icon shown above the label; falls back to `@src`. */
    icon?: ComponentLike<{ Args: { size?: string | number } }>;
    /** Alt text for `@src`. Leave empty when the image is decorative. */
    imageAlt?: string;
    /** Translated one-line label the tile exists to carry. */
    label: string;
    /** Image URL used when no `@icon` is supplied. */
    src?: string;
  };
  Element: HTMLDivElement;
}

/**
 * One tile in a grid of loan pros or cons: an icon (or image) over a short
 * label.
 *
 * Renders as a flat nested card — one of many peers inside an info card, so
 * the card around it stays the surface that reads as lifted.
 */
const QuestionsLoanTypesCardComponent: TOC<QuestionsLoanTypesCardSignature> = <template>
  <Card @radius="nested" @elevation="none" class="text-center h-full" ...attributes>
    {{#if @icon}}
      <div class="mx-auto mb-3 tio-row-center h-12 w-12 tio-fg-brand">
        <@icon @size="36" />
      </div>
    {{else if @src}}
      <img class="mx-auto mb-3 h-12 w-12" alt={{@imageAlt}} src={{@src}} />
    {{/if}}
    <span class="block tio-fg-secondary text-sm">{{@label}}</span>
  </Card>
</template>;

export default QuestionsLoanTypesCardComponent;
